import React from 'react';
import './HeaderText.css';
import {FormattedMessage} from "react-intl";

export default () => (
    <div className="youtube-header-text">
        <FormattedMessage id="youtube.header.specialists" />
    </div>
);

